<template>
  <div class="wrapper">
    <div class="form-wrapper">
      <el-form :inline="true" label-width="150px" style="margin-top: 16px;">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="项目部">
              <el-input :value="detail.deptName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="项目名称">
              <el-input :value="detail.projectName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="项目所属年度">
              <el-input :value="detail.belongYear" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="工程进度">
              <el-input :value="detail.projectProcess" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="合同金额">
              <el-input
                :value="formatMoneyNumber(detail.contractAmount)"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="已完成工作量">
              <el-input
                :value="formatMoneyNumber(detail.finishPriceSum)"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="上报计量">
              <el-input
                :value="formatMoneyNumber(detail.calculatePriceSum)"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="已收计量金额">
              <el-input
                :value="formatMoneyNumber(detail.receiptPriceSum)"
                readonly
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="收集团拨款金额">
              <el-input :value="formatMoneyNumber(detail.groupAmount)" readonly>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="贷款利率">
              <el-input :value="detail.loanPct" readonly>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="资金成本">
              <el-input
                :value="formatMoneyNumber(detail.capitalCost)"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="预计可实现收入比例">
              <el-input :value="detail.expectIncomePct" readonly>
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData1"
        border
        style="width: 100%;"
        :span-method="spanArrayMethod1"
        height="500"
      >
        <el-table-column
          label="项目"
          prop="title"
          fixed
          width="200"
        ></el-table-column>
        <el-table-column label="序号" prop="myindex" fixed width="50"></el-table-column>
        <el-table-column
          label="合作单位"
          prop="partyB"
          width="200"
        ></el-table-column>
        <el-table-column label="合同编号" width="200" prop="serialNumber">
        </el-table-column>
        <el-table-column label="合同金额（含税）" width="200" prop="amount">
          <!-- <template slot-scope="scope">
            <div>{{formatMoneyNumber(scope.row.amount)}}</div>
          </template> -->
        </el-table-column>
        <el-table-column
          label="合同内容"
          prop="contractContent"
          width="200"
        ></el-table-column>
        <el-table-column label="税后合价" width="200">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.settleAmount) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="裸税合价" width="200">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.cost) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="开具发票">
          <el-table-column label="含税金额" width="200">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.taxBillAmount) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额" width="200">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.noTaxBillAmount) }}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="未开具发票">
          <el-table-column label="含税金额" width="200">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.taxNoBillAmount) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="暂行税率" width="200">
            <template slot-scope="scope">
              <div v-if="!!scope.row.hideTaxRateCurrent == false">{{ formatPercentNumber(scope.row.taxRateCurrent) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额" width="200">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.noTaxNoBillAmount) }}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="累计已付款" width="200">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.alreadyPay) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="尚欠款" width="200">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.debtAmount) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已付款比例" width="200">
          <template slot-scope="scope">
            <div>{{ formatPercentNumber(scope.row.alreadyPayPct) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="本次拟付款" width="200">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.thisPay) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="再付款比例" width="200">
          <template slot-scope="scope">
            <div>{{ formatPercentNumber(scope.row.thisPayPct) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
        ></el-table-column>
      </el-table>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData2"
        border
        style="width: 100%;"
        :span-method="spanArrayMethod2"
      >
        <el-table-column label="序号" prop="myindex" width="50"></el-table-column>
        <el-table-column label="工程明细情况">
          <el-table-column label="项目名称" prop="title1"></el-table-column>
          <el-table-column
            :label="detail.projectName ? detail.projectName : ''"
            prop="title2"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="合同金额" width="200">
          <template slot-scope="scope">
              <div>
                {{ formatDisplayNumber(scope.row, "contractAmount") }}
              </div>
            </template>
        </el-table-column>
        <el-table-column label="预算金额">
          <el-table-column label="含税金额">
            <template slot-scope="scope">
              <div>{{ formatDisplayNumber(scope.row, "budgetTaxAmount") }}</div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额">
            <template slot-scope="scope">
              <div>
                {{ formatDisplayNumber(scope.row, "budgetNoTaxAmount") }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="实际发生金额">
          <el-table-column label="含税金额">
            <template slot-scope="scope">
              <div>{{ formatDisplayNumber(scope.row, "actTaxAmount") }}</div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额">
            <template slot-scope="scope">
              <div>{{ formatDisplayNumber(scope.row, "actNoTaxAmount") }}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
    </div>

    <div class="table-footer">
      <p>最近操作用户：{{ detail.operatorName }}</p>
      <p>最近操作日期：{{ detail.updateTime }}</p>
    </div>

    <div class="page-bottom-control">
      <el-button type="info" @click="closePage">关闭</el-button>
    </div>
  </div>
</template>

<script>
import { formatMoney, formatPercent } from "./utils";
import {
  formatEarningCostDetailTableData,
  formatEarningCostBasicTable1Data
} from "./EarningHelper";
/**
 * 收入成本管理-查看收入记录-基础数据
 */

export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    closefn: {
      type: Function,
    }
  },
  computed: {
    tableData1: function() {
      return formatEarningCostBasicTable1Data(this.detail);
    },
    tableData2: function() {
      return formatEarningCostDetailTableData(this.detail);
    }
  },
  methods: {
    formatDisplayNumber(rowData, key) {
      if (rowData.isPct) {
        return formatPercent(rowData[key]);
      }
      return formatMoney(rowData[key]);
    },
    spanArrayMethod1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan
        };
      }
    },
    spanArrayMethod2({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0) {
        return {
          rowspan: row.span1.rowspan,
          colspan: 1
        }
      }
      if (columnIndex == 1) {
        return {
          rowspan: row.span1.rowspan,
          colspan: row.span1.colspan
        };
      }
      if (columnIndex == 2) {
        return {
          rowspan: row.span2.rowspan,
          colspan: row.span2.colspan
        };
      }
    },
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    closePage() {
      if(this.closefn) {
        this.closefn()
        return
      }
      this.bus.$emit("tabClose", "incomingConstDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "incomeConstList"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 16px;
  box-sizing: border-box;
}

.table-wrapper {
  padding-bottom: 50px;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

/deep/.el-form-item {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 150px);
}

/deep/.el-select {
  width: 100%;
}

.page-bottom-control {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
